
import { Vue, Component, Prop } from "vue-property-decorator";
import SimpleDialog from "@/components/SimpleDialog.vue";
import { getBrowserKey } from "@/utils/navigator/userAgent";

@Component({
  components: { SimpleDialog },
})
export default class GeolocationHelpDialog extends Vue {
  @Prop({ type: Boolean, required: true, default: false})
  public dialog!: boolean;

  get instructions(): string[] {
    return this.$t(`geolocation.help.instructions.${this.browserKey}`) as unknown as string[];
  }

  get browserKey(): string {
    return getBrowserKey();
  }
}
